import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/nav-search-actions";

const navSearchReducer = (state = INITIAL_STATE.navSearch, action) => {
  switch (action.type) {
    case TYPES.OPEN_NAV_SEARCH: {
      return {
        ...state,
        open: true,
      };
    }

    case TYPES.CLOSE_NAV_SEARCH: {
      return {
        ...state,
        open: false,
      };
    }

    default:
      return state;
  }
};

export default navSearchReducer;
